export const SnoozeIcon = ({ color }: { color: string }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="snoozeIcon"
        >
            <path
                d="M12.975 5.59686C12.6599 5.53334 12.3338 5.5 12 5.5C9.29864 5.5 7.10879 7.68261 7.10879 10.375C7.10872 11.0717 7.06822 11.7265 6.6606 12.3269C6.3494 12.7797 5.92935 13.2434 5.8444 13.8002C5.70618 14.7063 6.32415 15.3353 7.08079 15.6487C9.98158 16.8504 14.0183 16.8504 16.9191 15.6487C17.6758 15.3353 18.2937 14.7063 18.1555 13.8002C18.0906 13.3747 17.8299 13.0035 17.5717 12.65"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6102 6.80005H16.9973C17.4995 6.80005 17.7506 6.80005 17.8175 6.95612C17.8844 7.1122 17.7135 7.29942 17.3718 7.67388L15.1503 9.82622C14.8086 10.2007 14.5433 10.3879 14.6102 10.544C14.6771 10.7001 15.0226 10.7001 15.5248 10.7001H17.8498"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.3999 16.55C9.69792 17.6714 10.749 18.5001 11.9999 18.5001C13.2508 18.5001 14.3019 17.6714 14.5999 16.55"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
